import { useEffect } from 'react';
import { trackViewContentEvent } from '@/tracking/facebook/trackingEvent';
import { IS_SSR } from '@/ots-constants';

interface IProps {
  region: string,
  uuid: string,
  shortTitle: string,
}

export const ResortFPCTracker = ({
  shortTitle,
  region,
  uuid,
} : IProps) => {
  useEffect(() => {
    if (shortTitle && region && uuid && !IS_SSR) {
      trackViewContentEvent(
        'resorts',
        region,
        [uuid],
        shortTitle,
        window.location.hostname,
      );
    }
  }, [shortTitle, region, uuid]);

  return null;
};
